import SiteFooterApp from './components/app';

export default SiteFooterApp;
